export function limparCampo(dados, campo) {
    if (dados && dados[campo]) {
        dados[campo] = dados[campo].replace(/[^A-Za-záàâãéèêíïóôõöúçñ\s]/g, "");
    }
}